exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".jobs-dashboard-container.teams{height:140vh}table.jobble-table.teams tbody tr td:first-child{min-width:300px}table.jobble-table.teams tbody tr td:last-child{width:50px}table.jobble-table.teams tbody tr td:nth-child(3){min-width:450px}table.jobble-table.teams tbody tr td:nth-child(3) img{float:left;border-radius:50%;width:26px;margin-right:15px;margin-bottom:10px}.create-new-team{width:300px;height:50px;line-height:50px;border-radius:6px;background:linear-gradient(270deg,#62c046,#5498b4);color:#fff;font-size:17px;font-weight:700;text-align:center;cursor:pointer}.create-new-team:hover{background:#74cf59;box-shadow:inset 0 30px 60px -12px rgba(50,50,93,.25),inset 0 18px 36px -18px rgba(0,0,0,.3)}#modal-create-team .modal-body input[type=text]{border-radius:5px;margin-bottom:10px}#modal-create-team .modal-body textarea{border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/components/teams/teams.css
// module id = 558
// module chunks = 0